import Vue from 'vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import localeTh from 'dayjs/locale/th'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(buddhistEra)
dayjs.extend(relativeTime)
dayjs.extend(isBetween)

// ตั้งค่า timezone เป็น Asia/Bangkok
dayjs.tz.setDefault('Asia/Bangkok')

Object.defineProperties(Vue.prototype, {
  $dayjs: {
    get () {
      return dayjs
    }
  }
})
